<template>
  <div :class="className" :style="{ height: height, width: width }"></div>
</template>

<script>
import chartResize from './mixins/chart-resize'

export default {
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: 'echarts'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions ({
      pieSeries,
      rest: {
        title = '',
        legend = {},
        name = $t('integration.sensor_status'),
        radius = '50%',
        isTip = false,
        labelLine,
        label
      },
      tooltip
    }) {
      if (pieSeries.length === 0) {
        this.chart._dom.innerHTML = $t('public.no_data')
        this.chart._dom.style.cssText =
          'text-align:center; color:#999; border: none;line-height: 300px'
        this.chart._dom.removeAttribute('_echarts_instance_')
        return
      }

      const option = {
        title: {
          text: title || '',
          // subtext: 'Fake Data',
          left: 'center',
          top: '2%',
          textStyle: {
            fontSize: '12px'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: legend || {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: name,
            type: 'pie',
            radius: radius,
            data: pieSeries,
            emphasis: {
              // 鼠标静置效果
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              // 饼图中心文字
              label: {
                show: isTip,
                fontSize: '12',
                fontWeight: 'bold'
              }
            },
            // 提示线
            labelLine,
            label
          }
        ]
      }
      if (tooltip) {
        option.tooltip = { ...option.tooltip, ...tooltip }
      }
      this.chart && this.chart.setOption(option, true)
    }
  }
}
</script>

<style></style>
